package one.healthium.insights.domain.models

sealed class MealPlanResultModel {
    data class Ready(val mealPlan: MealPlanModel) : MealPlanResultModel()
    data class Processing(val message: String) : MealPlanResultModel()
    data class Error(val message: String, val action: String) : MealPlanResultModel()
}
